export function filterEmptyKey (obj = {}) {
  for (const key in obj) {
    // 去除空格
    if (typeof obj[key] === 'string') {
      obj[key] = String(obj[key]).trim()
    }
    if (Object.prototype.hasOwnProperty.call(obj, key) && (obj[key] !== 0) && (obj[key] === null || obj[key] === '')) {
      delete obj[key]
    }
  }
  return obj
}

// 处理经纬度数据
export function handleTLnglatList (point) {
  // // 用于存储唯一的围栏编码
  // const fenceCode = []
  // // 用于存储每个围栏编码对应的绘制多边形的点
  // const drawPolyonList = []
  // // 用于存储每个围栏编码对应的设置多边形的点
  // const setPolyonList = []
  // point.forEach(item => {
  //   if (!fenceCode.includes(item.fenceCode)) {
  //     fenceCode.push(item.fenceCode)
  //   }
  // })
  // fenceCode.forEach(item => {
  //   drawPolyonList.push([])
  //   setPolyonList.push([])
  //   const drawPolyonPoints = []
  //   const setPolyonPoints = []
  //   point.forEach(item1 => {
  //     if (item === item1.fenceCode) {
  //       drawPolyonPoints.push(new AMap.LngLat(item1.longitude, item1.latitude))
  //       setPolyonPoints.push({
  //         longitude: item1.longitude,
  //         latitude: item1.latitude
  //       })
  //     }
  //   })
  //   drawPolyonList[drawPolyonList.length - 1] = drawPolyonPoints
  //   setPolyonList[setPolyonList.length - 1] = setPolyonPoints
  // })
  // return {
  //   drawPolyonList: drawPolyonList,
  //   setPolyonList: setPolyonList,
  //   fenceCode: fenceCode
  // }
  // 用于存储唯一的围栏编码
  const fenceCodeSet = new Set();
  // 用于存储每个围栏编码对应的绘制多边形的点
  const drawPolyonMap = new Map();
  // 用于存储每个围栏编码对应的设置多边形的点
  const setPolyonMap = new Map();

  // 遍历所有点，收集唯一的围栏编码，并将点分类存储到对应的映射中
  point.forEach(item => {
      const { fenceCode, longitude, latitude } = item;
      if (!fenceCodeSet.has(fenceCode)) {
          fenceCodeSet.add(fenceCode);
          drawPolyonMap.set(fenceCode, []);
          setPolyonMap.set(fenceCode, []);
      }
      const drawPoints = drawPolyonMap.get(fenceCode);
      const setPoints = setPolyonMap.get(fenceCode);
      // 尝试将经纬度转换为数字，避免无效值
      const lng = parseFloat(longitude);
      const lat = parseFloat(latitude);
      if (!isNaN(lng) && !isNaN(lat)) {
          drawPoints.push(new AMap.LngLat(lng, lat));
          setPoints.push({ longitude: lng, latitude: lat });
      }
  });

  // 将映射转换为数组
  const fenceCode = Array.from(fenceCodeSet);
  const drawPolyonList = fenceCode.map(code => drawPolyonMap.get(code));
  const setPolyonList = fenceCode.map(code => setPolyonMap.get(code));

  return {
      drawPolyonList,
      setPolyonList,
      fenceCode
  };
}

export function getMenu (menus = [], url) {
  for (let i = 0; i < menus.length; i++) {
    if (url.includes(menus[i].url) && menus[i].url) {
      return menus[i]
    } else if (menus[i].childNode && menus[i].childNode.length) {
      const menu = getMenu(menus[i].childNode, url)
      if (menu) return menu
    }
  }
}
// 加
export function addNum (num1, num2) {
  let sq1, sq2
  try {
    sq1 = num1.toString().split('.')[1].length
  } catch (e) {
    sq1 = 0
  }
  try {
    sq2 = num2.toString().split('.')[1].length
  } catch (e) {
    sq2 = 0
  }
  const m = Math.pow(10, Math.max(sq1, sq2))
  return (num1 * m + num2 * m) / m
}
// 减
export function reduceNum (arg1, arg2, num) { // num为保留位数,不传时不四舍五入
  arg1 = Number(arg1)
  arg2 = Number(arg2)
  let r1 = 0; let r2 = 0
  try { r1 = arg1.toString().split('.')[1].length } catch (e) {}
  try { r2 = arg2.toString().split('.')[1].length } catch (e) {}
  const m = Math.pow(10, Math.max(r1, r2))
  if (num || num === 0) {
    return ((arg1 * m - arg2 * m) / m).toFixed(num) // 注意：fixed四舍五入大于5会进1 5并不会进1
  }
  return (arg1 * m - arg2 * m) / m
}

/**
 *var latlngs = [
 *    [40.41646957397461, 115.95511436462402],
 *    [40.411319732666016, 115.95399856567383],
 *    [40.40994644165039, 115.9647274017334],
 *    [40.416555404663086, 115.96558570861816]
 *  ]
 * 输入一组坐标计算中心点
 */
export function mapGetCenter (pointArray) {
  const sortedLongitudeArray = pointArray.map(item => item[1]).sort()
  const sortedLatitudeArray = pointArray.map(item => item[0]).sort()
  const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(4)
  const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(4)
  return [centerLongitude, centerLatitude]
}

/**
 * 将数字转成中文大写
 * @params num
 */
export function toChinesNum (num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (let i = 0; i < strArr.length; i++) {
      newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

/**
 * 日期选择N天前
 * @param {number} day
 * @param {boolean} havetoday
 * @returns {any[]}
 */
export const dateBefore = (day, havetoday) => {
  const dateArr = []
  const date = new Date()
  if (!(day || '')) {
    day = 1
  }
  const date1 = new Date(date.getTime() - (!havetoday ? 24 * 60 * 60 * 1000 : 0))
  const date2 = new Date(date.getTime() - day * 24 * 60 * 60 * 1000)
  const val = date1.getFullYear() + '-' + addZero(date1.getMonth() + 1) + '-' + addZero(date1.getDate())
  const val2 = date2.getFullYear() + '-' + addZero(date2.getMonth() + 1) + '-' + addZero(date2.getDate())
  dateArr.push(val2, val)
  return dateArr
}
// 补0
function addZero (m) {
  return m < 10 ? '0' + m : m
}

export function getIndexPath (list = []) {
  if (list[0].childNode && list[0].childNode.length) {
    return getIndexPath(list[0].childNode)
  } else {
    return list[0].url
  }
}

/**
 * px转vw，页面为vw布局，
 * @return px单位数值
*/
export function px2vw (px) {
  return px // Math.ceil(px * (document.documentElement.clientWidth / 1920))
}

export function getPolygons (items = []) {
  let array = []
  if (items && items.length > 0) {
    const map = new Map()
    items.forEach((item) => {
      if (map.has(item.fenceCode)) {
        map.get(item.fenceCode).push([
          +item.longitude,
          +item.latitude
        ])
      } else {
        map.set(item.fenceCode, [[
          +item.longitude,
          +item.latitude
        ]])
      }
    })
    array = Array.from(map.entries())
  }
  return array
}

/**
 * 深度克隆
 * @param {*} obj 需要深度克隆的对象
 * @returns {*} 克隆后的对象或者原值（不是对象）
 */
export function deepClone(obj, cache = new WeakMap()) {
	if (obj === null || typeof obj !== 'object') return obj
	if (cache.has(obj)) return cache.get(obj)
	let clone
	if (obj instanceof Date) {
		clone = new Date(obj.getTime())
	} else if (obj instanceof RegExp) {
		clone = new RegExp(obj)
	} else if (obj instanceof Map) {
		clone = new Map(Array.from(obj, ([key, value]) => [key, deepClone(value, cache)]))
	} else if (obj instanceof Set) {
		clone = new Set(Array.from(obj, value => deepClone(value, cache)))
	} else if (Array.isArray(obj)) {
		clone = obj.map(value => deepClone(value, cache))
	} else if (Object.prototype.toString.call(obj) === '[object Object]') {
		clone = Object.create(Object.getPrototypeOf(obj))
		cache.set(obj, clone)
		for (const [key, value] of Object.entries(obj)) {
			clone[key] = deepClone(value, cache)
		}
	} else {
		clone = Object.assign({}, obj)
	}
	cache.set(obj, clone)
	return clone
}

/**
 * JS对象深度合并
 * @param {object} target 需要拷贝的对象
 * @param {object} source 拷贝的来源对象
 * @returns {object|boolean} 深度合并后的对象或者false（入参有不是对象）
 */
export function deepMerge(targetOrigin = {}, source = {}) {
	let target = deepClone(targetOrigin)
	if (typeof target !== 'object' || typeof source !== 'object') return false
	for (const prop in source) {
		if (!Object.prototype.hasOwnProperty.call(source, prop)) continue
		if (prop in target) {
			if (source[prop] == null) {
				target[prop] = source[prop]
			} else if (typeof target[prop] !== 'object') {
				target[prop] = source[prop]
			} else if (typeof source[prop] !== 'object') {
				target[prop] = source[prop]
			} else if (target[prop].concat && source[prop].concat) {
				target[prop] = target[prop].concat(source[prop])
			} else {
				target[prop] = deepMerge(target[prop], source[prop])
			}
		} else {
			target[prop] = source[prop]
		}
	}
	return target
}

/**
 * 等待一段时间
 * @param {number} ms 默认100毫秒
 * @default 100
 * @returns {Promise}
 */
export function sleep(ms = 100) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

